import { ColliState, ColliStateName } from '@frontend/colli/types';
import { ClassType } from '@frontend/common';
import { StatusBadge } from '@frontend/components/common';

export interface ColliStateBadgeProps {
    state: ColliStateName;
}

const COLLI_COLOR_MAP = new Map([
    [[ColliState.COLLI_COMPLETED.displayName], ClassType.SUCCESS],
    [
        [
            ColliState.COLLI_CREATED.displayName,
            ColliState.COLLI_PROCESSING.displayName,
            ColliState.COLLI_DROP_OFF_PENDING.displayName,
            ColliState.COLLI_IN_TRANSIT.displayName,
            ColliState.COLLI_LOST.displayName
        ],
        ClassType.WARNING
    ],
    [[ColliState.COLLI_CANCELLED.displayName, ColliState.COLLI_BACK_TO_SENDER.displayName], ClassType.INFO],
    [[ColliState.COLLI_COMPLETED_WITH_FAILURES.displayName, ColliState.COLLI_FAILED.displayName], ClassType.DANGER],
    [[ColliState.COLLI_PICK_UP_PENDING.displayName], ClassType.SECONDARY]
]);

const ColliStateBadge = ({ state }: ColliStateBadgeProps) => (
    <StatusBadge
        value={ColliState.getByValue(state)?.displayName ?? state}
        colorMap={COLLI_COLOR_MAP}
        textSize='xs'
    />
);

export default ColliStateBadge;
